module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Italic.d68b0a6.woff";